var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Graph",

    getDefaultProps () {
        return {"width":"22px","height":"22px","viewBox":"0 0 22 22","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>Icon/Graph</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Icon/Graph" fill="#000000">
      <g id="Graph">
        <rect id="Rectangle-15" x="1" y="3" width="2" height="17"/>
        <rect id="Rectangle-15-Copy-2" x="4" y="13" width="3" height="7"/>
        <rect id="Rectangle-15-Copy-3" x="8" y="11" width="3" height="8"/>
        <rect id="Rectangle-15-Copy-4" x="12" y="8" width="3" height="12"/>
        <rect id="Rectangle-15-Copy-5" x="16" y="13" width="3" height="6"/>
        <rect id="Rectangle-15-Copy" x="3" y="19" width="18" height="1"/>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/ui/images/Graph.svg